export const environment = {
  "name": "green",
  "prefix": "green.",
  "type": "development",
  "apiUrl": "https://green.api.accredible.com",
  "experimentsApiUrl": "https://experiments-a.api.accredible.com",
  "socketUrl": "https://green.socket.accredible.com",
  "credentialNetUrl": "https://green.credential.net",
  "courseFinderUrl": "https://green.coursefinder.io",
  "dashboardUrl": "https://green.dashboard.accredible.com",
  "accountsUrl": "https://green.accounts.accredible.com",
  "spotlightUrl": "https://green.employment.accredible.com",
  "salesCalculatorUrl": "https://green.calculator.accredible.com",
  "accredishareUrl": "https://green.accredishare.api.accredible.com",
  "directoryOfDirectoriesUrl": "https://green.directories.accredible.com",
  "lerUrl": "https://green.app.mycareerjourney.com",
  "lerLandingUrl": "https://www.mycareerjourney.com/",
  "lerPosthogId": "phc_RYEh5RfEbQo1UtoEJOTvTg1ChpBRICdRfrMN41CoEi9",
  "privateWalletUrl": "https://green.wallet.accredible.com",
  "stripeKey": "pk_test_cAeVkx5DhTMwelsEudggtgxC",
  "getSocialId": "a0c42bca",
  "theme": "",
  "version": "26.16.31",
  "recaptchaV2SiteKey": "6LcOWiETAAAAADQyIj7-BSOG8KNsnYIsV84jJDfM",
  "recaptchaV3SiteKey": "6LeLojsaAAAAAB8OV2zHmQvFW66cq79i-xJqdu8j",
  "googleFontApiKey": "AIzaSyCgKPyvoy_y1MMvTtTqIex7OIBlVjbYkYE",
  "themeMicroserviceBaseUrl": "https://theme.ms.credential.net",
  "theming": false,
  "themingS3BaseUrl": "",
  "integrationsApiUrl": "https://greenintegrations.api.accredible.com",
  "zoomAppClientId": "ElQ8D1iBQNOdL2GFT7Mj7A",
  "dashboardGainsightTagKey": "AP-EGY1FB9PXTHZ-2-4",
  "recipientGainsightTagKey": "AP-DDKMXRZFO5TE-2-4",
  "spotlightGainsightTagKey": "AP-XETC94EVLZS5-2-4",
  "unlayerProjectId": "236376",
  "slackClientId": "2228435857.8884109478882",
  "faro": {
    "accounts": {
      "collectorUrl": "https://faro-collector-prod-us-east-0.grafana.net/collect/2b6b0ed6154f28fb818e9d079ab986c6",
      "enabled": false
    },
    "recipientPortal": {
      "collectorUrl": "https://faro-collector-prod-us-east-0.grafana.net/collect/afc01ec8cd5a37812f578fe635d50e23",
      "enabled": false
    },
    "spotlight": {
      "collectorUrl": "https://faro-collector-prod-us-east-0.grafana.net/collect/3be43a205c41130e126b766bdc898023",
      "enabled": false
    },
    "credentialRenderer": {
      "collectorUrl": "https://faro-collector-prod-us-east-0.grafana.net/collect/6f00dd90b0cb4e210dd837b1072ca855",
      "enabled": false
    }
  },
  "rubricSalt": "chtM@CyP_.7iF.kuQXBv",
  "liveCredentialNetUrl": "https://live.credential.net"
};